import React from 'react';
import { Formik } from 'formik';
import RegisterForm from '../components/main/RegisterForm';
import { validateRegistration } from '../../components/Validations';
import Swal from 'sweetalert2';
import Layout from "../Layout";
import ExcelReader from "../../common/components/base/ExcelReader";
import LoadingSpinner from "../../common/components/LoadingSpinner/LoadingSpinner";
import useAppStore from '../../store/appStore';
import { useUserGroups } from '../../hooks/useUserGroups';
import { useCreateUser } from '../../hooks/useCreateUser';
import { useCreateUsers } from '../../hooks/useCreateUsers';

/* TODO: Replaced GraphQL mutations with REST hooks
const CREATE_USER = gql`
  mutation createUser($input:UserInput){
    createUser(input:$input){
      token
    }
  }
`;

const REGISTER_USERS = gql`
mutation createUsers($users:[Users]){
  createUsers(users:$users)
}
`;
*/

const AdminRegister = (props) => {
  // Get user data from Zustand store instead of GraphQL
  const user = useAppStore((state) => state.user);
  const loading = !user || !user.me;
  const data = user ? { me: user.me } : null;
  const error = null;

  // Replace GraphQL GET_USER_GROUPS with REST hook
  const { data: userGroupsData, isPending: userGroupsLoading, error: userGroupsError } = useUserGroups();

  // Initialize REST hooks for user creation
  const createUserMutation = useCreateUser({
    onSuccess: () => {
      Swal.fire({
        type: 'success',
        text: 'User registered.',
        showConfirmButton: false,
        timer: 1500
      });
      props.history.push('/admin-settings/users');
    },
    onError: () => {
      Swal.fire({
        type: 'error',
        text: 'Error registering user.',
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: 'Close'
      });
    }
  });

  // Extract isPending from mutation
  const { mutate: createUser, isPending: isCreatingUser } = createUserMutation;

  // Initialize REST hook for bulk user creation via Excel
  const createUsersMutation = useCreateUsers({
    onSuccess: () => {
      Swal.fire({
        type: 'success',
        title: 'Users registered successfully!',
        showConfirmButton: false,
        timer: 1500
      });
    },
    onError: () => {
      Swal.fire({
        type: 'error',
        text: 'Error registering users.',
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: 'Close'
      });
    }
  });

  // Function to handle Excel upload and transform data for REST API
  const registerUsers = async (value) => {
    const userList = []
    value.map((item) => userList.push({
      name: item.NAME,
      surname: item.SURNAME,
      sigla: item.SIGLA,
      email: item.EMAIL_LOGIN,
      password: item.PSW,
      userRole: item.USER_ROLE.toUpperCase(),
      expirationDate: item.EXPIRATION_DATE,
      privacyPolicy: true
    }))
    
    console.log('registerUsers - Input value from Excel:', value);
    console.log('registerUsers - Transformed userList:', userList);
    
    // Use REST hook instead of GraphQL mutation
    createUsersMutation.mutate(userList);
  }

  if (loading || userGroupsLoading) return <LoadingSpinner styles={{ paddingTop: 60 }} />;
  if (error) return `Error! ${error.message}`;
  if (userGroupsError) return `Error! ${userGroupsError.message}`;
  
  // Protezione per dati non ancora caricati
  if (!data || !data.me) {
    return <LoadingSpinner styles={{ paddingTop: 60 }} />;
  }
  
  if (!userGroupsData || !userGroupsData.userGroups) {
    return <LoadingSpinner styles={{ paddingTop: 60 }} />;
  }
  
  const userRole = data.me.userRole;
  
  // Prepara i courseGroups dal REST hook
  const allUserGroups = userGroupsData.userGroups.records || [];
  const courseGroups = allUserGroups.map((item) => ({ value: item._id, label: item.name }));

  return (
    <Layout name="Register User">
      <div className="wizard-container">
        <div className="col-md-8 col-12 mr-auto ml-auto">
          <div className="card card-wizard active" data-color="rose" id="wizardProfile">

            <Formik
              initialValues={{ name: '', surname: '', sigla: '', username: '', password: '', userRole: 'student', courseGroups: [], privacyPolicy: true, expirationDate: '' }}
              validate={validateRegistration}
              onSubmit={async (values, { setSubmitting }) => {
                try {
                  
                  // Create user data object for REST API
                  const userData = {
                    uid: null,
                    name: values.name,
                    surname: values.surname,
                    sigla: values.sigla,
                    email: values.username,
                    password: values.password,
                    userRole: values.userRole,
                    courseGroups: values.courseGroups,
                    privacyPolicy: values.privacyPolicy,
                    expirationDate: values.expirationDate
                  };
                  
                  createUser(userData);
                } catch (error) {
                  setSubmitting(false);
                  Swal.fire({
                    type: 'error',
                    title: 'Error',
                    text: error.message || 'Failed to create user',
                    showConfirmButton: true
                  });
                }
              }}
            >
              {({ values, isSubmitting, handleChange, setFieldValue }) => (
                <RegisterForm values={values}
                  isSubmitting={isSubmitting || isCreatingUser}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  userRole={userRole}
                  courseGroups={courseGroups}
                  open={()=>{}}/>
              )}
            </Formik>

            <ExcelReader
              label={"Select list of users"}
              onLoad={(value) => registerUsers(value)}
              buttonLabel={createUsersMutation.isPending ? "Registering..." : "Register Users"}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default AdminRegister;
